import actions from './actions';
import getters from './getters';
import mutations from './mutations';
import { EventStageState } from './types';

import { appMode } from '@/assets/utilfunctions';
import { openTvWindow } from '@/services/dialogs/utils';
import { getValueFromLocalstore } from '@/services/localStorage.service';

function getTvWindow() {
  try {
    const { open } = JSON.parse(window.name);
    return open ? openTvWindow('') : undefined;
  } catch (e) {
    return undefined;
  }
}

function defaultState(): EventStageState {
  return {
    heartBeatDate: undefined,
    heartBeatInterval: undefined,
    fullScreen: false,
    transitions: {},
    hasUserEnabledCaptions: false,
    captionLanguage: '',
    transition: {
      active: false,
      item: undefined,
      time: undefined
    },
    showEngagementPanel: true,
    showChatOnMobile: false,
    showChatOnTV: false,
    forceShowViewAsAttendeeTooltip: false,
    attendeeTooltipMessage: '',
    isTVMode: appMode === 'tv',
    isLiveStreamMode: appMode === 'liveStream',
    progressBarConfig: {
      showProgressBar: false,
      totalVideoDuration: 0,
      currentVideoDuration: 0
    },
    isHLSVideoPlayerHovered: false,
    isSimuliveTestBufferMessageShown: false,
    muted: appMode === 'tv' && !!+getValueFromLocalstore('tvSpeakerMuted'),
    greenRoomVideoMuted: false,
    userProfileDropdownOpen: false,
    tvWindow: getTvWindow() as Window,
    transitionToMainStage: false,
    connectToBackstage: true,
    volume: {
      stage: {
        level: '100',
        mutedAt: '100'
      },
      backstage: {
        level: '100',
        mutedAt: '100'
      }
    },
    backStageVisibility: true,
    speakerNotesVisibility: false,
    usePPTAnimations: false,
    runOfShowSetup: {
      isRunning: false,
      isPlaying: false,
      seekPosition: 0,
      duration: 0
    }
  };
}

export default {
  state: defaultState(),
  getters,
  actions,
  mutations,
  namespaced: true
};
